<template>
  <div>
  <Card>
      <Row>
        <i-col span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem prop="name" :label-width="0">
              <i-input v-model="searchForm.name" placeholder="请输入用户/主机/来源ip" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getSpringBoradLogList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getSpringBoradLogList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getLogsList, disconnect, generateVideo } from '@/api/springboard'
export default {
  name: 'SpringBoardLogs',
  props: ['ip'],
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '用户', key: 'user', align: 'center', minWidth: 80 },
        { title: '系统用户', key: 'system_user', align: 'center', minWidth: 120 },
        { title: '登录类型', key: 'login_type', align: 'center', minWidth: 100 },
        { title: '主机', key: 'host', align: 'center', minWidth: 100 },
        { title: '来源ip', key: 'remote_ip', align: 'center', minWidth: 120 },
        { title: '登陆时间', key: 'time_start', align: 'center', minWidth: 150 },
        { title: '结束时间', key: 'time_finish', align: 'center', minWidth: 150 },
        {
          title: '状态',
          key: 'is_finished',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row
            const color = row.is_finished === true ? 'error' : 'success'
            const text = row.is_finished === true ? '已断开' : '连接中'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 90,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              if (params.row.is_finished) {
                if (params.row.login_type === 'ssh') {
                  return h('div', [
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        title: '回放',
                        disabled: !params.row.is_finished
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.playLogs(params)
                        }
                      }
                    }, '回放')
                  ])
                } else if (params.row.login_type === 'rdp') {
                  // if (params.row.video_path) {
                  return h('div', [
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        title: '回放',
                        disabled: !params.row.is_finished
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.playLogs(params)
                        }
                      }
                    }, '回放')
                  ])
                  // } else {
                  //   return h('div', [
                  //     h('Button', {
                  //       props: {
                  //         type: 'primary',
                  //         size: 'small',
                  //         title: '生成',
                  //         disabled: !params.row.is_finished
                  //       },
                  //       style: {
                  //         marginRight: '5px'
                  //       },
                  //       on: {
                  //         click: () => {
                  //           this.generate(params)
                  //         }
                  //       }
                  //     }, '生成')
                  //   ])
                  // }
                }
              } else {
                return h('div', [
                  h('Poptip', {
                    props: {
                      confirm: true,
                      placement: 'bottom',
                      title: '你确定要断开吗?',
                      transfer: true
                    },
                    on: {
                      'on-ok': () => {
                        this.disconnect(params)
                      }
                    }
                  }, [
                    h('Button', {
                      props: {
                        type: 'error',
                        size: 'small',
                        title: 'Delete',
                        disabled: params.row.is_finished
                      },
                      style: {
                        marginRight: '5px'
                      }
                    }, '断开')
                  ])
                ])
              }
            } else {}
          }
        }
      ],
      tableData: [],
      user_all: [],
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
    ip () {
      getSpringBoradLogList()
    }
  },
  methods: {
    getSpringBoradLogList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name,
        ip: this.ip
      }
      getLogsList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getSpringBoradLogList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    disconnect (params) {
      disconnect(params.row.id, params.row.identifier).then(res => {
        this.$Message.success(res.data.msg)
        this.getSpringBoradLogList()
      })
    },
    generate (params) {
      if (params.row.video_path) {
        this.$Message.error('视频已经生成，不可重复生成')
      } else {
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'ios-loading',
                  size: 100
                }
              }),
              h('div', 'Loading')
            ])
          }
        })
        setTimeout(() => {
          this.$Spin.hide()
          this.getSpringBoradLogList()
          this.$Message.success('视频生成成功')
        }, 8000)
        generateVideo(params.row.id).then(res => {
          if (res.data.code === 200) {
          } else {
            this.$Message.error(res.data.msg)
          }
        })
      }
    },
    playLogs (params) {
      if (params.row.login_type === 'ssh') {
        if (params.row.log_content) {
          this.handleRender(params)
        } else {
          this.$Modal.warning({
            title: '日志生成中,请稍后刷新查看'
          })
        }
      } else if (params.row.login_type === 'rdp') {
        if (params.row.video_path) {
          let iTop = (window.screen.availHeight - 30 - 800) / 2
          let iLeft = (window.screen.availWidth - 10 - 1000) / 2
          window.open(params.row.video_path, '_blank', 'toolbar=yes, innerHeight=800, innerWidth=1000, left=' + iLeft +
           ', top=' + iTop + ', status=no, toolbar=no, menubar=no, location=no, resizable=no, scrollbars=0, titlebar=no, width=1000, height=800')
        } else {
          this.$Modal.warning({
            title: '日志生成中,请稍后刷新查看'
          })
        }
      }
    },
    handleRender (params) {
      let reg = RegExp('<br />', 'g')
      this.$Modal.info({
        width: '750px',
        title: '日志详情',
        render: (h) => {
          return h('div', [
            h('span', {style: {color: '#515a6e'}}, '用户:'),
            h('span', {style: {color: 'green'}}, params.row.user),
            h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '系统用户:'),
            h('span', {style: {color: 'green'}}, params.row.system_user),
            h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '主机:'),
            h('span', {style: {color: 'green'}}, params.row.host),
            h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '开始时间:'),
            h('span', {style: {color: 'green'}}, params.row.time_start),
            h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '结束时间:'),
            h('span', {style: {color: 'green'}}, params.row.time_finish),
            h('Divider', {
            }),
            h('Input', {
              props: {
                type: 'textarea',
                value: params.row.log_content.replace(reg, ''),
                autofocus: true,
                placeholder: '',
                disabled: true,
                autosize: { minRows: 6, maxRows: 20 }
              },
              style: {
                width: '98%',
                height: '450px'
              }
            })
          ])
        }
      })
    }
  },
  mounted: function () {
    this.getSpringBoradLogList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
.ivu-input[disabled], fieldset[disabled] .ivu-input {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #666;
}
</style>
